import { Col } from "antd";
import React from "react";

export default function InsuranceBreakDownLabel({ label, data, icon }) {
  return (
    <Col xs={24} sm={24} md={24} lg={8}>
      <div
        style={{
          height: 121,
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          background: "rgba(223, 218, 255, 0.7)",
          borderRadius: "8px",
        }}
      >
        <div className="circle" style={{ marginLeft: 20 }}>
          <img className="icon-center" src={icon} alt="" />
        </div>

        <div style={{ marginLeft: 25 }}>
          <div style={{ fontSize: 20, fontWeight: 400, color: "#4D3280", marginBottom: 10 }}>{label}</div>
          <div style={{ fontSize: 24, color: "#4D3280", fontWeight: 600 }}>{data}</div>
        </div>
      </div>
    </Col>
  );
}
